import React from 'react';

interface DannebrogFlagProps {
  size?: number;
  className?: string;
}

const DannebrogFlag: React.FC<DannebrogFlagProps> = ({ size = 28, className }) => {
  // Official Dannebrog proportions: 37:28, Nordic cross 4 units wide, vertical bar at x=10
  const width = size * (37 / 28);
  const height = size;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 28"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Dannebrog"
      role="img"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <rect width="37" height="28" fill="#C60C30" />
      {/* Horizontal white bar */}
      <rect x="0" y="12" width="37" height="4" fill="#FFFFFF" />
      {/* Vertical white bar */}
      <rect x="10" y="0" width="4" height="28" fill="#FFFFFF" />
    </svg>
  );
};

export default DannebrogFlag;
